import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import { showToaster } from "../../../services/helper";
import jwt from "jwt-simple";
import { checkUserLogin } from "../../../services/authService";
import Button from "../../../components/atoms/buttons/button";
import { useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { joinUserToRoom } from "../../../services/socket.service";

export default function Login(props) {
  const history = useHistory();
  let DisplayMode = useSelector((state) => state.project.DisplayMode);
  const [errorStatus, setErrorStatus] = useState();
  const [uploadProgress, setUploadProgress] = useState(false);
  const [type, setType] = useState("text");
  useEffect(() => {
    if (localStorage.getItem("_olive_user")) {
      history.push("/project-list");
    }
    console.log(props.history.location.state?.id);
  }, []);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .trim()
        .email("Email is invalid")
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Email is required"),
      password: Yup.string()
        .trim()
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
          "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
        )
        .required("Password is required"),
    }),
    onSubmit: (values) => {
      console.log("here", values);
      setUploadProgress(true);
      try {
        checkUserLogin(values).then((response) => {
          console.log(response);
          if (
            response !== "" &&
            response !== undefined &&
            response !== null &&
            response.data !== "" &&
            response.data !== undefined &&
            response.data !== null
          ) {
            setUploadProgress(false);
            if (
              response.data.userData !== "" &&
              response.data.userData !== undefined &&
              response.data.userData !== null
            ) {
              if (response.data.userData.isActive === 1) {
                if (
                  response.data.userData.status === 1 &&
                  response.data.userData.locked === false
                ) {
                  // showToaster('You Have Logged in Successfully', 'success');
                  window.localStorage.setItem(
                    "_user",
                    JSON.stringify(response.data.token)
                  );
                  let loggedinUserDetails = jwt.encode(
                    response.data.userData,
                    process.env.REACT_APP_JWT_SECRET,
                    "HS512"
                  );
                  window.localStorage.setItem(
                    "_olive_user",
                    JSON.stringify(loggedinUserDetails)
                  );
                  joinUserToRoom();
                  // console.log( response.data);
                  // if (
                  //   response.data.userData.planId !== undefined &&
                  //   response.data.userData.role == 0
                  // ) {
                  //   if (props.history.location.state?.rpath !== undefined) {
                  //     // history.push("/download/" + props.history.location.state?.id);
                  //     history.push(props.history.location.state?.rpath);
                  //   } else {
                  //     history.push("/project-list");
                  //   }
                  // } else {
                  //   history.push(
                  //     `/payment-methods/${response.data.userData.id}`
                  //   );
                  // }
                  if (props.history.location.state?.rpath !== undefined) {
                    // history.push("/download/" + props.history.location.state?.id);
                    history.push(props.history.location.state?.rpath);
                  } else {
                    history.push("/project-list");
                  }
                } else {
                  showToaster(
                    "User is inactive ,please contact the administrator to activate the account",
                    "warning"
                  );
                }
              } else {
                showToaster(
                  "User is inactive ,please contact the administrator to activate the account",
                  "warning"
                );
              }
            } else {
              showToaster("Something went wrong. Please Try Again", "warning");
            }
          } else if (
            response !== "" &&
            response !== undefined &&
            response !== null &&
            response.status !== ""
          ) {
            if (
              response.message !== "" &&
              response.message !== undefined &&
              response.message !== null
            ) {
              console.log(response);
              // showToaster(response.message, 'warning');
              // this.setState({ errorStatus: response.message })
              setErrorStatus(response.message);
            } else {
              setUploadProgress(false);
              showToaster("No response from the server", "warning");
            }
            setUploadProgress(false);
          } else {
            setUploadProgress(false);

            showToaster("No response from the server", "warning");
          }
        });
      } catch (e) {
        setUploadProgress(false);
        showToaster("Something went wrong. Please Try Again", "warning");
        // this.setState({ errorStatus: e.response.data.errors })
        setErrorStatus(e.response.data.errors);
      }
    },
  });
  const eyeButton = () => {
    // var passEye = document.querySelector('.pass-eye');
    // passEye.onclick = ()=>{
    const passHolder = document.querySelector(".password-holder");
    passHolder.classList.toggle("active");
    var x = document.getElementsByClassName("password-input")[0];
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
    // }
  };

  return (
    // <form onSubmit={formik.handleSubmit}>
    <div className={DisplayMode ? "theme dark" : "theme"}>
      <div className="d-flex login-wrapper h-100">
        <div className="login-left-part">
          <div className="login-logo">
            {/* <img src="assets/img/Logo.svg" className="img-fluid" /> */}
            <svg
              width="133"
              height="32"
              viewBox="0 0 133 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.8532 11.1445H11.1445V15.1613V20.8532H20.8532V11.1445Z"
                fill=""
              />
              <path
                d="M23.3492 0H0V23.3514C0 27.0439 2.31479 30.1951 5.57339 31.4364V22.0475V15.1613V5.57339H22.0475C24.463 5.57339 26.4266 7.53704 26.4266 9.95247V13.2133H32V8.64859C32 3.8714 28.1264 0 23.3492 0Z"
                fill=""
              />
              <path
                d="M26.4266 26.4266H11.1445V32H32V18.7867H26.4266V26.4266Z"
                fill=""
              />
              <path
                d="M52.19 17C50.6232 17 49.2147 16.6497 47.9644 15.9492C46.73 15.2331 45.7567 14.2367 45.0445 12.9602C44.3482 11.668 44 10.1813 44 8.5C44 6.81868 44.3482 5.33974 45.0445 4.06319C45.7567 2.77106 46.73 1.77473 47.9644 1.07418C49.2147 0.358059 50.6232 0 52.19 0C53.7567 0 55.1573 0.358059 56.3918 1.07418C57.642 1.77473 58.6153 2.77106 59.3117 4.06319C60.0238 5.33974 60.3799 6.81868 60.3799 8.5C60.3799 10.1813 60.0238 11.668 59.3117 12.9602C58.6153 14.2367 57.642 15.2331 56.3918 15.9492C55.1573 16.6497 53.7567 17 52.19 17ZM52.19 14.1044C53.8042 14.1044 55.0386 13.5907 55.8932 12.5632C56.7637 11.5357 57.1989 10.1813 57.1989 8.5C57.1989 6.81868 56.7637 5.46429 55.8932 4.43681C55.0386 3.40934 53.8042 2.8956 52.19 2.8956C50.5757 2.8956 49.3334 3.40934 48.4629 4.43681C47.6083 5.46429 47.181 6.81868 47.181 8.5C47.181 10.1813 47.6083 11.5357 48.4629 12.5632C49.3334 13.5907 50.5757 14.1044 52.19 14.1044Z"
                fill=""
              />
              <path
                d="M63.0331 0.326923H66.0717V14.011H72.9086V16.6731H63.0331V0.326923Z"
                fill=""
              />
              <path
                d="M74.9026 0.326923H77.9412V16.6731H74.9026V0.326923Z"
                fill=""
              />
              <path
                d="M94.469 0.326923L88.558 16.6731H85.6855L79.7745 0.326923H82.8369L87.1099 12.353L91.4066 0.326923H94.469Z"
                fill=""
              />
              <path
                d="M96.3002 0.326923H106.935V3.22253H99.41V6.70192H105.25V9.59753H99.41V13.7775H107.173V16.6731H96.3002V0.326923Z"
                fill=""
              />
              <path
                d="M123.742 12.7967H117.688L116.311 16.6731H113.368L119.279 0.326923H122.151L128.062 16.6731H125.119L123.742 12.7967ZM122.792 10.1813L120.727 4.34341L118.638 10.1813H122.792Z"
                fill=""
              />
              <path
                d="M129.961 0.326923H133V16.6731H129.961V0.326923Z"
                fill=""
              />
              <path
                d="M48.8484 32C47.9068 32 47.0693 31.794 46.3359 31.3819C45.6026 30.9698 45.0276 30.3883 44.6111 29.6374C44.2037 28.8773 44 27.9982 44 27C44 26.0018 44.2082 25.1273 44.6247 24.3764C45.0503 23.6163 45.6342 23.0302 46.3767 22.6181C47.1191 22.206 47.9611 22 48.9027 22C49.3735 22 49.8217 22.0504 50.2472 22.1511C50.6728 22.2518 51.053 22.3892 51.388 22.5632L51.2251 24.0742C50.4374 23.6987 49.6587 23.511 48.8891 23.511C48.2191 23.511 47.6442 23.6621 47.1644 23.9643C46.6936 24.2573 46.3359 24.6694 46.0915 25.2005C45.847 25.7225 45.7248 26.3223 45.7248 27C45.7248 27.6777 45.8425 28.2821 46.0779 28.8132C46.3223 29.3352 46.68 29.7473 47.1508 30.0494C47.6216 30.3425 48.192 30.489 48.862 30.489C49.2875 30.489 49.6859 30.4432 50.0571 30.3516C50.4374 30.2601 50.8267 30.1227 51.2251 29.9396L51.388 31.4368C50.6275 31.8123 49.781 32 48.8484 32Z"
                fill=""
              />
              <path
                d="M56.8688 32C55.9634 32 55.1576 31.794 54.4514 31.3819C53.7452 30.9698 53.1884 30.3883 52.7809 29.6374C52.3825 28.8773 52.1834 27.9982 52.1834 27C52.1834 26.0018 52.3825 25.1273 52.7809 24.3764C53.1884 23.6163 53.7452 23.0302 54.4514 22.6181C55.1576 22.206 55.9634 22 56.8688 22C57.7742 22 58.58 22.206 59.2862 22.6181C59.9924 23.0302 60.5447 23.6163 60.9431 24.3764C61.3505 25.1273 61.5542 26.0018 61.5542 27C61.5542 27.9982 61.3505 28.8773 60.9431 29.6374C60.5447 30.3883 59.9924 30.9698 59.2862 31.3819C58.58 31.794 57.7742 32 56.8688 32ZM56.8688 30.4615C57.8376 30.4615 58.58 30.141 59.0961 29.5C59.6212 28.859 59.8838 28.0256 59.8838 27C59.8838 25.9744 59.6212 25.141 59.0961 24.5C58.58 23.859 57.8376 23.5385 56.8688 23.5385C55.9 23.5385 55.1531 23.859 54.6279 24.5C54.1028 25.141 53.8402 25.9744 53.8402 27C53.8402 28.0256 54.1028 28.859 54.6279 29.5C55.1531 30.141 55.9 30.4615 56.8688 30.4615Z"
                fill=""
              />
              <path
                d="M63.1116 22.1923H64.7141L68.9921 28.7582V22.1923H70.5811V31.8077H69.2773L64.6869 24.8434V31.8077H63.1116V22.1923Z"
                fill=""
              />
              <path
                d="M74.561 23.7033H71.8448V22.1923H78.8526V23.7033H76.1364V31.8077H74.561V23.7033Z"
                fill=""
              />
              <path
                d="M80.1143 22.1923H86.0899V23.7033H81.7168V26.0385H85.1528V27.5495H81.7168V30.2967H86.2257V31.8077H80.1143V22.1923Z"
                fill=""
              />
              <path
                d="M87.7668 22.1923H89.3693L93.6473 28.7582V22.1923H95.2363V31.8077H93.9325L89.3422 24.8434V31.8077H87.7668V22.1923Z"
                fill=""
              />
              <path
                d="M99.2163 23.7033H96.5001V22.1923H103.508V23.7033H100.792V31.8077H99.2163V23.7033Z"
                fill=""
              />
              <path
                d="M107.82 22.1923H111.12C113.329 22.1923 114.434 23.2271 114.434 25.2967C114.434 26.359 114.149 27.1511 113.578 27.6731C113.008 28.1951 112.193 28.456 111.134 28.456H109.422V31.8077H107.82V22.1923ZM110.944 27.0962C111.577 27.0962 112.048 26.9542 112.356 26.6703C112.673 26.3773 112.831 25.9286 112.831 25.3242C112.831 24.7106 112.673 24.2619 112.356 23.978C112.048 23.6941 111.568 23.5522 110.916 23.5522H109.422V27.0962H110.944Z"
                fill=""
              />
              <path
                d="M115.791 22.1923H119.132C120.155 22.1923 120.956 22.435 121.535 22.9203C122.115 23.4057 122.405 24.1337 122.405 25.1044C122.405 25.7729 122.264 26.3223 121.984 26.7527C121.703 27.1831 121.3 27.5266 120.775 27.783L122.907 31.8077H121.101L119.24 28.1676H119.172H117.393V31.8077H115.791V22.1923ZM118.833 26.8077C119.494 26.8077 119.978 26.6658 120.286 26.3819C120.603 26.0888 120.761 25.6859 120.761 25.1731C120.761 24.0925 120.132 23.5522 118.874 23.5522H117.393V26.8077H118.833Z"
                fill=""
              />
              <path
                d="M128.315 32C127.409 32 126.603 31.794 125.897 31.3819C125.191 30.9698 124.634 30.3883 124.227 29.6374C123.828 28.8773 123.629 27.9982 123.629 27C123.629 26.0018 123.828 25.1273 124.227 24.3764C124.634 23.6163 125.191 23.0302 125.897 22.6181C126.603 22.206 127.409 22 128.315 22C129.22 22 130.026 22.206 130.732 22.6181C131.438 23.0302 131.99 23.6163 132.389 24.3764C132.796 25.1273 133 26.0018 133 27C133 27.9982 132.796 28.8773 132.389 29.6374C131.99 30.3883 131.438 30.9698 130.732 31.3819C130.026 31.794 129.22 32 128.315 32ZM128.315 30.4615C129.283 30.4615 130.026 30.141 130.542 29.5C131.067 28.859 131.33 28.0256 131.33 27C131.33 25.9744 131.067 25.141 130.542 24.5C130.026 23.859 129.283 23.5385 128.315 23.5385C127.346 23.5385 126.599 23.859 126.074 24.5C125.549 25.141 125.286 25.9744 125.286 27C125.286 28.0256 125.549 28.859 126.074 29.5C126.599 30.141 127.346 30.4615 128.315 30.4615Z"
                fill=""
              />
            </svg>
          </div>
          <div className="login-infog"></div>
        </div>
        <div className="d-flex align-items-center justify-content-center login-right-part">
          <div className="login-container w-100">
            <div className="login-cap">Login to your Account</div>
            <div className="login-para fs-20">
              Welcome to production automation
            </div>
            <form onSubmit={formik.handleSubmit} id="login-form">
              <div className="login-inp-wrapper">
                <div className="custom-input-holder">
                  <div className="custom-label">User Name</div>
                  <div className="custom-input-container position-relative">
                    <span className="user-avatar-inpt">
                      <img
                        src="assets/img/user-icon.png"
                        className="img-fluid"
                      />
                    </span>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      className="custom-input"
                      placeholder="Enter your Email"
                      disabled={uploadProgress}
                    />
                  </div>
                  {formik.touched.email && formik.errors.email ? (
                    <div className="input-error-msg">{formik.errors.email}</div>
                  ) : null}
                  {/* <div className="input-error-msg">Invalid username</div> */}
                </div>
                <div className="custom-input-holder">
                  <div className="custom-label">Password</div>
                  <div className="custom-input-container position-relative password-holder">
                    <span className="pass-lock">
                      <svg
                        height="48"
                        viewBox="0 0 48 48"
                        width="48"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 0h48v48h-48z" fill="none" />
                        <path d="M36 16h-2v-4c0-5.52-4.48-10-10-10s-10 4.48-10 10v4h-2c-2.21 0-4 1.79-4 4v20c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-20c0-2.21-1.79-4-4-4zm-12-10.2c3.42 0 6.2 2.78 6.2 6.2v4h-12.2v-4h-.2c0-3.42 2.78-6.2 6.2-6.2zm12 34.2h-24v-20h24v20zm-12-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" />
                      </svg>
                    </span>

                    <span className="pass-eye" onClick={eyeButton}>
                      <span className="hide-pass-eye">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="512.000000pt"
                          height="512.000000pt"
                          viewBox="0 0 512.000000 512.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <g
                            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                            stroke="none"
                          >
                            <path
                              d="M559 4561 l-144 -139 325 -326 c201 -202 321 -329 315 -334 -6 -5
                            -59 -51 -120 -103 -303 -257 -658 -662 -861 -981 l-74 -118 58 -92 c177 -282
                            482 -647 733 -880 289 -268 545 -450 824 -588 237 -116 420 -177 650 -217 138
                            -23 452 -23 590 0 274 47 542 147 818 304 l48 27 349 -349 350 -350 142 143
                            143 142 -323 323 c-177 177 -322 325 -322 328 0 4 21 23 48 43 97 76 324 292
                            445 424 218 238 371 431 496 630 l72 112 -59 92 c-177 282 -482 647 -733 880
                            -496 460 -954 711 -1469 804 -133 25 -467 25 -600 1 -281 -51 -560 -157 -827
                            -313 l-33 -19 -348 348 -348 348 -145 -140z m2291 -631 c134 -27 317 -89 445
                            -150 431 -207 891 -613 1276 -1125 l72 -95 -86 -113 c-145 -191 -245 -306
                            -417 -478 -142 -143 -351 -329 -369 -329 -4 0 -89 83 -190 184 l-184 184 45
                            89 c86 167 112 274 113 463 0 199 -40 346 -139 514 -284 476 -915 628 -1387
                            333 -17 -11 -35 4 -174 143 -85 85 -155 158 -155 162 0 12 222 115 325 151
                            109 38 253 73 355 87 107 15 351 4 470 -20z m-1310 -635 c166 -166 184 -187
                            173 -204 -246 -394 -187 -908 142 -1236 125 -125 299 -224 471 -267 118 -29
                            330 -32 449 -4 89 20 206 65 278 108 26 15 51 28 55 28 4 0 77 -70 162 -155
                            127 -127 152 -157 140 -166 -42 -30 -236 -115 -338 -149 -205 -68 -301 -84
                            -512 -84 -213 1 -311 17 -515 85 -496 167 -1042 609 -1496 1213 l-71 96 73 98
                            c179 239 421 503 619 676 108 95 171 146 180 146 3 0 88 -83 190 -185z m1164
                            -155 c113 -29 190 -73 277 -160 126 -125 188 -284 176 -454 -5 -78 -40 -216
                            -55 -216 -9 0 -792 783 -792 792 0 7 98 39 155 51 52 12 168 5 239 -13z m-287
                            -722 c216 -216 393 -396 393 -400 0 -15 -138 -50 -216 -55 -289 -20 -555 184
                            -620 473 -12 54 -15 101 -11 158 5 78 40 216 55 216 4 0 184 -177 399 -392z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span className="show-pass-eye">
                        <svg
                          fill="none"
                          height="24"
                          stroke="#000"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      </span>
                    </span>
                    <input
                      id="password"
                      name="password"
                      type="password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                      className="custom-input password-input"
                      placeholder="Enter your Password"
                      disabled={uploadProgress}
                    />
                  </div>
                  {formik.touched.password && formik.errors.password ? (
                    <div className="input-error-msg">
                      {formik.errors.password}
                    </div>
                  ) : null}
                  {/* <div className="input-error-msg">Invalid password</div> */}
                  <div
                    className="input-error-msg"
                    style={{ visibility: errorStatus ? "visible" : "hidden" }}
                  >
                    {errorStatus}
                  </div>
                </div>

                <div className="login-btn-holder mt-4">
                  {uploadProgress === true ? (
                    <Button type="button" className="btn btn-primary login-btn">
                      Logging in...{" "}
                      <CircularProgress size="1rem" color="inherit" />
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-primary login-btn">
                      Login to your account
                      <span className="login-arrow">
                        <svg
                          enable-background="new 0 0 96 96"
                          height="96px"
                          id="arrow_right"
                          version="1.1"
                          viewBox="0 0 96 96"
                          width="96px"
                          xmlns="http://www.w3.org/2000/svg"
                          xlink="http://www.w3.org/1999/xlink"
                        >
                          <path d="M12,52h62.344L52.888,73.456c-1.562,1.562-1.562,4.095-0.001,5.656c1.562,1.562,4.096,1.562,5.658,0l28.283-28.284l0,0  c0.186-0.186,0.352-0.391,0.498-0.609c0.067-0.101,0.114-0.21,0.172-0.315c0.066-0.124,0.142-0.242,0.195-0.373  c0.057-0.135,0.089-0.275,0.129-0.415c0.033-0.111,0.076-0.217,0.099-0.331C87.973,48.525,88,48.263,88,48l0,0  c0-0.003-0.001-0.006-0.001-0.009c-0.001-0.259-0.027-0.519-0.078-0.774c-0.024-0.12-0.069-0.231-0.104-0.349  c-0.039-0.133-0.069-0.268-0.123-0.397c-0.058-0.139-0.136-0.265-0.208-0.396c-0.054-0.098-0.097-0.198-0.159-0.292  c-0.146-0.221-0.314-0.427-0.501-0.614L58.544,16.888c-1.562-1.562-4.095-1.562-5.657-0.001c-1.562,1.562-1.562,4.095,0,5.658  L74.343,44L12,44c-2.209,0-4,1.791-4,4C8,50.209,9.791,52,12,52z" />
                        </svg>
                      </span>
                    </Button>
                  )}
                </div>

                {/* <div className="forgt-wrapper text-right">
                  <Link to="forgot" className="forgot-password">
                    Forgot Password?
                  </Link>
                </div> */}
                <p>
                  Forgot your password?
                  <Link to="forgot" className="forgot-password">
                    Recover Password
                  </Link>
                  {/* <span>Recover Password</span> */}
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    // </form>
  );
}

// import "./styles.css";

// Login.propTypes = {

// };
